import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';

import { HttpApiService } from '@core/http-legacy';

import type { CurrentUserPreferencesRequestData } from './current-user-preferences.types';

@Injectable({ providedIn: 'root' })
export class CurrentUserPreferencesHttpClient {
  protected readonly httpApi = inject(HttpApiService);

  public loadCurrentUserPreferences(): Observable<any> {
    return this.httpApi.get('/admin/preferences', null, { skipCompany: true });
  }

  public updateCurrentUserPreferences(data: Partial<CurrentUserPreferencesRequestData>) {
    return this.httpApi.patch('/admin/preferences', {}, data, { skipCompany: true });
  }
}
